var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMna2N49EUvbh67V(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 20.6695C14.8098 20.6695 14.6198 20.5995 14.4698 20.4495L7.94979 13.9295C6.88979 12.8695 6.88979 11.1295 7.94979 10.0695L14.4698 3.54953C14.7598 3.25953 15.2398 3.25953 15.5298 3.54953C15.8198 3.83953 15.8198 4.31953 15.5298 4.60953L9.00979 11.1295C8.52979 11.6095 8.52979 12.3895 9.00979 12.8695L15.5298 19.3895C15.8198 19.6795 15.8198 20.1595 15.5298 20.4495C15.3798 20.5895 15.1898 20.6695 14.9998 20.6695Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMna2N49EUvbh67V);
export default __webpack_public_path__ + "static/media/mna2n49e-uvbh67v.4bdbb985adf8ac46bb6ff788295f0cb9.svg";
export { ForwardRef as ReactComponent };